@if (showBanner) {
  <div class="pwa-install-banner">
    <div class="pwa-install-banner__content">
      <img class="pwa-install-banner__icon" src="/favicon.ico" alt="Octopus Music School" />
      <div class="pwa-install-banner__text">
        <strong>Octopus Music School</strong>
        @if (!isIos) {
          <span>Install app for a better experience</span>
        } @else {
          <span> Tap <img class="pwa-install-banner__share-icon" src="assets/icons/ios-share-icon.svg" alt="Share" /> then <strong>"Add to Home Screen"</strong> </span>
        }
      </div>
    </div>
    <div class="pwa-install-banner__actions">
      @if (!isIos) {
        <button class="pwa-install-banner__install-btn" (click)="install()">Install</button>
      }
      <button class="pwa-install-banner__close-btn" (click)="dismiss()" aria-label="Dismiss">&#10005;</button>
    </div>
  </div>
}
